export const SET_LOADING_AUTH_REFRESH = 'SET_LOADING_AUTH_REFRESH';

interface IAuthState {
    loadingAuthRefresh: boolean;
}

export const setLoadingAuthRefresh = (input: boolean) => {
  return {
    type: SET_LOADING_AUTH_REFRESH,
    payload: input
  }
}
